<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="top">
          <div class="big">
            <div class="logo">
              <img src="../assets/img-07-03/LOGO  1860250-tuya.png" alt="" class="img-logo"/>
            </div>
            <div class="menu">
              <el-menu :default-active="this.$route.path" class="el-menu-demo" mode="horizontal" router menu-trigge="click">
                <el-menu-item index="/home" ><template slot="title">首页</template></el-menu-item>
                <!-- <el-menu-item index="/aboutUs" ><template slot="title">关于我们</template></el-menu-item> -->

                <el-submenu index="/solution">
                  <template slot="title">解决方案</template>
                  <el-menu-item index="/major">钉钉专业版</el-menu-item>
                  <el-menu-item index="/onlyDingding">钉钉专属版</el-menu-item>
                  <el-menu-item index="/teamB">项目(Teambition)</el-menu-item>
                  <el-menu-item index="/videoconferencing">视频会议</el-menu-item>
                  <el-menu-item index="/onlyWork">定制工作台</el-menu-item>
                  <!-- <el-menu-item index="/engineeringManagement">工程管理</el-menu-item>
                    <el-menu-item index="/digitalFactory">数字工厂</el-menu-item>
                    <el-menu-item index="/highWork">高级工作台</el-menu-item>
                    <el-menu-item index="/OACloud">云端办公室</el-menu-item> -->
                  <el-menu-item index="/yunshu">云枢</el-menu-item>
                  <el-menu-item index="/chuanyun">氚云</el-menu-item>
                  <el-menu-item index="/yida">宜搭</el-menu-item>
                </el-submenu>

                <el-menu-item index="/didaima">
                  <template slot="title">低代码</template>
<!--                  <el-menu-item index="/yida">宜搭</el-menu-item>-->
<!--                  <el-menu-item index="/chuanyun">氚云</el-menu-item>-->
<!--                  <el-menu-item index="/yunshu">云枢</el-menu-item>-->
                </el-menu-item>
                <el-menu-item index="/dingConnect"><template slot="title">智能硬件</template></el-menu-item>
                <!-- <el-submenu index="/news" class="sdsdsd">
                  <template slot="title">新闻资讯</template>
                  <el-menu-item index="/news" class="aa-menu">公司动态</el-menu-item>
                  <el-menu-item index="/teamStyle" class="aa-menu">团队风采</el-menu-item>
                  <el-menu-item index="/realInfo" class="aa-menu">钉钉资讯</el-menu-item>
                  <el-menu-item index="/course" class="aa-menu">钉钉教程</el-menu-item>
                </el-submenu> -->

                <!-- <el-submenu index="/server" @click="jumpCP">
                  <template slot="title" >产品服务</template>
                  <el-menu-item index="/dingFlash">钉闪会</el-menu-item>
                  <el-menu-item index="/dingdingWord">钉钉文档</el-menu-item>
                  <el-menu-item index="/yida">宜搭</el-menu-item>
                  <el-menu-item index="/yunshu">云枢</el-menu-item>
                  <el-menu-item index="/chuanyun">氚云</el-menu-item>
                </el-submenu> -->
                <el-menu-item index="/customerCase"><template slot="title">客户案例</template></el-menu-item>
                <el-submenu index="/aboutUs" class="sdsdsd">
                  <template slot="title">关于我们</template>
                  <el-menu-item index="/aboutUs" class="aa-menu">公司简介</el-menu-item>
                  <el-menu-item index="/talentPeople" class="aa-menu">人才招聘</el-menu-item>
                </el-submenu>
                <el-menu-item index="/getUs"><template slot="title">联系我们</template></el-menu-item>
              </el-menu>
              <div class="line"></div>
            </div>

          </div>
        </div>
      </el-header>
      <el-main>
        <div class="right-zixun">
          <div class="img-right-lis" @click="clickZX1">
            <!-- <img src="./imgs/img-kefu-s1.png" alt=""> -->
            <span class="iconfont icon-kefu"></span>
            <p>在线咨询</p>
          </div>
          <div class="img-right-lis">
            <span class="iconfont icon-weixin"></span>
            <p>微信咨询</p>
            <div class="weixin-box">
              <img src="./imgs/mg-weixin-weiweima-people.png" alt="" class="weixinpeople">
            </div>
          </div>
          <div class="img-right-lis">
            <span class="iconfont icon-24gl-telephone"></span>
            <p>电话咨询</p>
            <div class="dianhua-box">
              18205080131
            </div>
          </div>
          <div class="img-right-lis" @click="clickSY">
            <span class="iconfont icon-tubiaoxiugai img-color"></span>
            <p>免费试用</p>
          </div>
        </div>
        <router-view></router-view>
      </el-main>
      <el-footer>
        <FooterPage />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import FooterPage from "@/components/FooterPage.vue";
export default {
  components: {
    FooterPage
  },
  methods: {
    jumpCP(){
      console.log("111");
      this.$router.push({name:"server"})
    },

    clickZX1(){
      window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
    },

    clickSY(){
      window.open('https://isite.baidu.com/site/wjzkc6f4/53b343e9-93a8-4fff-8b41-80c73584960d')
    }
  }
};
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  // box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  > .big {
    width: 84%;
    height: 120px;
    margin: 0 auto;
    > .logo {
      width: 558px;
      height: 75px;
      float: left;
      margin-top: 22.5px;
      > img {
        width: 100%;
        height: 100%;

      }
    }
    > .menu {
      width: calc(100% - 558px);
      height: 100%;
      display: flex;
      justify-content: center;
      padding-left: 160px;
      // margin: 16px 0 16px 12px;
      // background-color: red;
      /deep/ .el-menu{
        height: 120px;
        display: flex;
        align-items: center;
      }
      /deep/ .el-menu--horizontal>.el-menu-item{
        color: #000!important;
      }
      /deep/ .el-submenu__title{
        color: #000!important;
        font-size: 24px;
      }
      /deep/ .el-submenu__title:hover{
        color: #1890ff!important;
      }
      /deep/ .el-submenu__title:hover i{
        color: #1890ff!important;
      }
      /deep/ .el-menu-item{
        color: #000!important;
        font-size: 24px;
        margin: 0 20px;
      }
      /deep/ .el-menu-item:hover{
        color: #1890ff!important;
      }

    }
  }
}
.right-zixun{
  width: 126px;
  height: 504px;
  // background-color: rgb(201,231,255);
  background-color: #fff;
  position: fixed;
  right: 2px;
  top: 60%;
  z-index: 100000;
  transform: translate(0,-250px);
  // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img-right-lis{
    width: 100%;
    height: 126px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #d0d0d0;
    transition: all 0.2s linear;
    position: relative;
    .iconfont{
      font-size: 55px;
    }
    p{
      margin-top: 8px;
    }
    .weixin-box{
      width: 217px;
      height: 220px;
      position: absolute;
      right: 126px;
      top: -45px;
      background-color: rgb(201,231,255);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      opacity: 0;
      .weixinpeople{
        width: 200px;
        height: 190px;
      }
    }
    .dianhua-box{
        width: 320px;
        height: 125px;
        position: absolute;
        right: 124px;
        top: 0px;
        background-color: #007FFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 35px;
        letter-spacing: 2.4px;
        color: #fff;
        font-weight: bold;
        opacity: 0;
    }
  }
  .img-right-lis:hover{
    background-color: #007FFF;
  }
  .img-right-lis:hover .iconfont,.img-right-lis:hover p{
    color: #fff;
  }
  .img-right-lis:hover .weixin-box{
    opacity: 1;
  }
  .img-right-lis:hover .dianhua-box{
    opacity: 1;
  }
  .img-right-lis:nth-child(1),.img-right-lis:nth-child(2){
    border-bottom: none;
  }
  .img-color {
    transform: scale(0.8);
    color: #2c3e50;
  }
}
</style>

